exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"-webkit-box-orient": "vertical",
	"-webkit-box-direction": "normal",
	"-webkit-flex-direction": "flex-direction",
	"-ms-flex-direction": "flex-direction",
	"flex-direction": "flex-direction",
	"-webkit-flex-wrap": "flex-wrap",
	"-ms-flex-wrap": "flex-wrap",
	"flex-wrap": "flex-wrap",
	"-webkit-box-flex": "flex-grow",
	"-webkit-flex-grow": "flex-grow",
	"-ms-flex-positive": "flex-grow",
	"flex-grow": "flex-grow",
	"-webkit-flex-shrink": "flex-shrink",
	"-ms-flex-negative": "flex-shrink",
	"flex-shrink": "flex-shrink",
	"-webkit-box-pack": "justify-content",
	"-webkit-justify-content": "justify-content",
	"-ms-flex-pack": "justify-content",
	"justify-content": "justify-content",
	"-webkit-box-align": "align-items",
	"-webkit-align-items": "align-items",
	"-ms-flex-align": "align-items",
	"align-items": "align-items",
	"-webkit-align-content": "align-content",
	"-ms-flex-line-pack": "align-content",
	"align-content": "align-content",
	"-webkit-align-self": "align-self",
	"-ms-flex-item-align": "align-self",
	"align-self": "align-self"
};